<template>
    <XWindow
        ref="window"
        title="Purchase order"
        windowClass="height-auto bts-window"
        scrollClass="collection height-auto"
        :width="width"
        :height="height"
        :isMaximized="isMaximized"
        formStatus="view"
        @dialog-state="dialogState"
    >
        <template #left-button>
            <mdb-btn type="button" color="elegant" size="sm" :disabled="loading || !selected" @click="loadPurchaseOrder">
                <i class="el-icon-refresh"></i> Refresh
            </mdb-btn>
        </template>

        <mdb-tabs class="table-tabs bts-form-tabs mb-0 form mt-1" :active="active" default :links="tabs">
            <template slot="form-slot">
                <mdb-row class="tab-row">
                    <mdb-col col="4" class="tab-col"><ThatsInput :show_error="false" labelClass="col-md-4" fieldClass="col-md-8 pl-0" label="ID" vid="open-po-id" :value="header.DocEntry" :readOnly="true" :rules="''" size="sm" /></mdb-col>
                    <mdb-col col="4" class="tab-col"><ThatsInput :show_error="false" labelClass="col-md-4" fieldClass="col-md-8 pl-0" label="PO No." vid="open-po-number" :value="header.DocNum" :readOnly="true" :rules="''" size="sm" /></mdb-col>
                    <mdb-col col="4" class="tab-col"><ThatsInput :show_error="false" labelClass="col-md-4" fieldClass="col-md-8 pl-0" label="Status" vid="open-po-status" :value="formattedStatus" :readOnly="true" :rules="''" size="sm" /></mdb-col>
                </mdb-row>
                <mdb-row class="tab-row">
                    <mdb-col col="4" class="tab-col"><ThatsInput :show_error="false" labelClass="col-md-4" fieldClass="col-md-8 pl-0" label="Vendor Code" vid="open-po-vendor-code" :value="header.CardCode" :readOnly="true" :rules="''" size="sm" /></mdb-col>
                    <mdb-col col="4" class="tab-col"><ThatsInput :show_error="false" labelClass="col-md-4" fieldClass="col-md-8 pl-0" label="Vendor Ref." vid="open-po-vendor-reference" :value="header.NumAtCard" :readOnly="true" :rules="''" size="sm" /></mdb-col>
                </mdb-row>
                <mdb-row class="tab-row">
                    <mdb-col col="4" class="tab-col"><ThatsInput :show_error="false" labelClass="col-md-4" fieldClass="col-md-8 pl-0" label="Document Date" vid="open-po-document-date" :value="formattedDocumentDate" :readOnly="true" :rules="''" size="sm" /></mdb-col>
                    <mdb-col col="4" class="tab-col"><ThatsInput :show_error="false" labelClass="col-md-4" fieldClass="col-md-8 pl-0" label="Due Date" vid="open-po-due-date" :value="formattedDueDate" :readOnly="true" :rules="''" size="sm" /></mdb-col>
                </mdb-row>

                <div class="bts-window-form mt-1">
                    <el-alert v-if="error" :title="error" type="error" :closable="false" show-icon class="mb-2" />
                    <div v-loading="loading" ref="spreadsheet" class="purchase-order-spreadsheet" :style="{ height: spreadsheetHeight }"></div>
                </div>
            </template>
        </mdb-tabs>
    </XWindow>
</template>

<script>
import { mapActions } from 'vuex';
import { mdbBtn, mdbCol, mdbRow, mdbTabs } from 'mdbvue';
import XWindow from '../../components/thats/XWindow.vue';
import { ThatsInput } from '../../components/thats/Thats';
import jspreadsheet from '../../jsexcel/jexcel';
import { formatManifestDate } from '../manifest/formatters';

const defaultItemPhoto = 'https://media.thatsliving.com/assets/default-item-img-small.jpg';

export default {
    name: 'OpenPurchaseOrderForm',
    components: { XWindow, ThatsInput, mdbBtn, mdbCol, mdbRow, mdbTabs },
    data() {
        return {
            isMaximized: true,
            width: 1100,
            height: 600,
            active: 0,
            tabs: [{ text: 'Details', slot: 'form-slot' }],
            header: {},
            items: [],
            selected: null,
            spreadsheet: null,
            spreadsheetHeight: 'calc(100vh - 240px)',
            spreadsheetOptions: {
                copyCompatibility: true,
                download: false,
                csvFileName: 'open-purchase-order',
                editable: false,
                allowCopy: true,
                selectionCopy: true,
                allowDeleteRow: false,
                allowInsertRow: false,
                allowManualInsertRow: false,
                allowInsertColumn: false,
                allowManualInsertColumn: false,
                allowDeleteColumn: false,
                allowRenameColumn: false,
                columnDrag: false,
                rowDrag: false,
                columnSorting: true,
                tableOverflow: true,
                tableWidth: 'calc(100vw - 3px)',
                tableHeight: 'calc(100vh - 240px)',
                freezeColumns: 2,
                minDimensions: [8, 1],
                minSpareCols: 0,
                contextMenu: false,
                data: [],
                updateTable(instance, cell, col, row, val) {
                    if ((row % 2) === 1) cell.parentNode.style.backgroundColor = '#FAFAFA';
                    if (col === 1) {
                        const photo = val || defaultItemPhoto;
                        cell.innerHTML = '<img src="' + photo + '" alt="Item photo" style="width:80px;height:80px;object-fit:contain">';
                        cell.parentNode.style.height = '84px';
                    }
                },
                columns: [
                    { type: 'text', name: 'ItemCode', title: 'Item Code', width: 210, align: 'left', readOnly: true },
                    { type: 'text', name: 'photo', title: 'Photo', width: 90, align: 'center', readOnly: true },
                    { type: 'text', name: 'ItemName', title: 'Item Name', width: 320, align: 'left', readOnly: true },
                    { type: 'numeric', name: 'Quantity', title: 'Ordered Qty', width: 140, align: 'right', mask: '#,##0.00', decimal: '.', readOnly: true },
                    { type: 'numeric', name: 'OpenQty', title: 'Open Qty', width: 140, align: 'right', mask: '#,##0.00', decimal: '.', readOnly: true },
                    { type: 'text', name: 'UOM', title: 'UOM', width: 110, align: 'left', readOnly: true },
                    { type: 'text', name: 'WhsCode', title: 'Warehouse', width: 150, align: 'left', readOnly: true },
                    { type: 'text', name: 'LineStatus', title: 'Line Status', width: 130, align: 'left', readOnly: true }
                ]
            },
            loading: false,
            error: '',
            requestId: 0
        };
    },
    computed: {
        formattedStatus() {
            return this.header.DocStatus === 'O' ? 'Open' : (this.header.DocStatus || '');
        },
        formattedDocumentDate() {
            return formatManifestDate(this.header.DocDate);
        },
        formattedDueDate() {
            return formatManifestDate(this.header.DocDueDate);
        }
    },
    beforeDestroy() {
        this.resetView();
    },
    methods: {
        ...mapActions('OpenPurchaseOrderModule', ['getPurchaseOrder']),
        openDialog(row, connection) {
            this.resetView();
            this.width = window.innerWidth;
            this.height = window.innerHeight;
            this.header = { ...row };
            this.selected = { docEntry: Number(row.DocEntry), connection };
            this.$refs.window.openDialog();
            return this.loadPurchaseOrder();
        },
        closeDialog() {
            this.resetView();
            this.$refs.window.closeDialog();
        },
        dialogState(open) {
            if (!open) this.resetView();
        },
        resetView() {
            this.requestId += 1;
            this.destroySpreadsheet();
            this.header = {};
            this.items = [];
            this.selected = null;
            this.error = '';
            this.loading = false;
        },
        destroySpreadsheet() {
            if (this.spreadsheet) {
                this.spreadsheet.destroy();
                this.spreadsheet = null;
            }
        },
        async renderSpreadsheet(requestId) {
            this.destroySpreadsheet();
            await this.$nextTick();
            if (requestId !== this.requestId || !this.$refs.spreadsheet) return;
            this.spreadsheetOptions.data = this.items.map(item => [
                item.ItemCode || '',
                item.photo || defaultItemPhoto,
                item.ItemName || '',
                item.Quantity == null ? '' : item.Quantity,
                item.OpenQty == null ? '' : item.OpenQty,
                item.UOM || '',
                item.WhsCode || '',
                item.LineStatus === 'O' ? 'Open' : (item.LineStatus === 'C' ? 'Closed' : (item.LineStatus || ''))
            ]);
            this.spreadsheetOptions.minDimensions = [8, Math.max(this.items.length, 1)];
            this.spreadsheet = jspreadsheet(this.$refs.spreadsheet, this.spreadsheetOptions);
        },
        async loadPurchaseOrder() {
            const requestId = ++this.requestId;
            this.destroySpreadsheet();
            this.items = [];
            this.error = '';
            if (!this.selected || !Number.isInteger(this.selected.docEntry) || this.selected.docEntry < 1) {
                this.error = 'Invalid purchase order selection.';
                return;
            }
            this.loading = true;
            try {
                const response = await this.getPurchaseOrder(this.selected);
                if (requestId !== this.requestId) return;
                const data = response && response.data;
                if (!data || !data.header || Number(data.header.DocEntry) !== this.selected.docEntry || !Array.isArray(data.items)) {
                    throw new Error('Invalid purchase order response');
                }
                this.header = data.header;
                this.items = data.items;
                await this.renderSpreadsheet(requestId);
            } catch (error) {
                if (requestId !== this.requestId) return;
                this.error = error.response && error.response.status === 404
                    ? 'This purchase order is no longer open.'
                    : 'Unable to load this purchase order. Please try Refresh again.';
            } finally {
                if (requestId === this.requestId) this.loading = false;
            }
        }
    }
};
</script>
